

const GeojsonLayer = (data) => {
	// TODO causes re render
	// const selectedIds = new Set(selection);
	// const ffeatures = data['features'].filter(f => !selectedIds.has(f.properties.id));
	// const ffeatures = data['features']
	const ffeatures = data['features'].filter(f => f.geometry.type === 'Polygon' || f.geometry.type === 'MultiPolygon')

	return {
		id: '3d-building-layer',
		type: 'fill-extrusion',
		source: {
			type: "geojson",
			data: {type: 'FeatureCollection', features: ffeatures},
		},
		// filter:  ["all", ...selection.map(id => ["!=", "id", id])],
		paint: {
			'fill-extrusion-height': [
			  "interpolate",
			  ["linear"],
			  ["get", "height"],
			  3.5,
			  3.5,
			  301,
			  301
			],
			'fill-extrusion-base': 0,
			'fill-extrusion-color': ["get", "color"],
			// 'fill-extrusion-color': [
			//   "match",
			//   ["get", "status"],
			//   [
			//     "Brisbane Development Map Completed"
			//   ],
			//   "white",
			//   [
			//     "Brisbane Development Map Approved"
			//   ],
			//   "green",
			//   [
			//     "Brisbane Development Map MasterPlan/Vision"
			//   ],
			//   "purple",
			//   [
			//     "Brisbane Development Map Proposed"
			//   ],
			//   "red",
			//   [
			//     "Brisbane Development Map Under Construction"
			//   ],
			//   "blue",
			//   "darkgray"
			// ]
		}
	}
}

export default GeojsonLayer;